var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cardbox"},[_c('DetailWeblog',{staticClass:"pt-20 px-10 pb-10 mb-40",attrs:{"coin":_vm.coin}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }